import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, X, ExternalLink } from 'lucide-react';

export default function CookieBanner({ onNavigateCookies }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('veritas_cookie_consent');
    if (!consent) setTimeout(() => setVisible(true), 1500);
  }, []);

  const accept = () => {
    localStorage.setItem('veritas_cookie_consent', 'accepted');
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem('veritas_cookie_consent', 'rejected');
    window['ga-disable-G-XVVLNGGFP5'] = true;
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 25 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
        >
          <div className="max-w-4xl mx-auto bg-zinc-900 border border-zinc-700 rounded-xl shadow-2xl shadow-black/50 p-5 flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="flex items-start gap-3 flex-1">
              <Cookie className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-white text-sm font-mono font-bold mb-1">Usamos cookies</p>
                <p className="text-zinc-400 text-xs leading-relaxed">
                  Utilizamos cookies propias para el funcionamiento del servicio (sesión, historial) y Google Analytics para estadísticas anónimas de uso. No usamos cookies publicitarias.{' '}
                  <button
                    onClick={onNavigateCookies}
                    className="text-blue-400 hover:text-blue-300 underline inline-flex items-center gap-0.5 transition-colors"
                  >
                    Más info <ExternalLink className="w-3 h-3" />
                  </button>
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2 flex-shrink-0 w-full md:w-auto">
              <button
                onClick={reject}
                className="flex-1 md:flex-none px-4 py-2 border border-zinc-600 hover:border-zinc-400 text-zinc-400 hover:text-white font-mono text-xs uppercase tracking-wider rounded transition-all"
              >
                Solo necesarias
              </button>
              <button
                onClick={accept}
                className="flex-1 md:flex-none px-4 py-2 bg-blue-600 hover:bg-blue-500 text-white font-mono text-xs uppercase tracking-wider rounded transition-all"
              >
                Aceptar todo
              </button>
              <button onClick={reject} className="text-zinc-600 hover:text-zinc-400 transition-colors p-1">
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
